// ConsultationPackage/PriceByConsultationConfig.tsx
import React, {useEffect, useState} from 'react';
import {axios} from 'Auth/axiosConfig';
import pprint from 'Utils/pprint';
import CircularProgress from 'Core/components/elements/CircularProgress';
import {FR} from "WideLayout/Layouts";

interface PriceByConsultationConfigProps {
    configId: number | null;
    currency: string;
    className?: string;
}

const PriceByConsultationConfig: React.FC<PriceByConsultationConfigProps> = ({
                                                                                 configId,
                                                                                 currency,
                                                                                 className,
                                                                             }) => {
    const [price, setPrice] = useState<number | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!configId) {
            setPrice(null);
            setError(null);
            return;
        }

        const fetchPrice = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await axios.get('/api/v1/consultations/package/price-by-config/', {
                    params: {
                        config_id: configId,
                        currency: currency,
                    },
                });
                pprint('PriceByConsultationConfig -> response', response.data);
                setPrice(response.data.amount);
            } catch (err: any) {
                pprint('PriceByConsultationConfig -> error', err);
                setError(err?.response?.data?.detail || 'Ошибка при загрузке цены');
            } finally {
                setLoading(false);
            }
        };

        fetchPrice();
    }, [configId, currency]);

    if (!configId) return null;

    if (loading) {
        return (
            <FR w={'fit-content'}>
                <CircularProgress size="24px"/>
            </FR>
        );
    }

    if (error) {
        return <div className={className} style={{color: 'red'}}>{error}</div>;
    }

    if (price === null) {
        return null;
    }

    return (
        <div className={className}>
            <span>Цена: {price} {currency}</span>
        </div>
    );
};

export default PriceByConsultationConfig;
